import { render, staticRenderFns } from "./AgencyStatements.vue?vue&type=template&id=18d66c6f&"
import script from "./AgencyStatements.vue?vue&type=script&lang=js&"
export * from "./AgencyStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgencyStatements.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
})
